export const IMAGE_DIMENSIONS = {
  WIDTH: 171,
  HEIGHT: 33
};
